
import Vue from 'vue'
import RoadConceptJBTransformer from '@/transformers/catalog/services/roadConceptJB'

export default (query, { camp, catalog }, opts={}) => {
	const payload = {search_data: query, camp, catalog }
	const searchByName = opts.searchByName

	const typeOfSearch = searchByName ? 'name' : 'code'

	const url = `/purchase/search_concept/${typeOfSearch}/`

	return Vue.$http.post(url, payload)
		.then(response => {
			const data = response.data

			return RoadConceptJBTransformer.fetchCollection(data)
		})
}



// WEBPACK FOOTER //
// ./src/services/purchase/searchConcept.js